<template>
  <div>
    <AgreementRenderer
      v-for="agreement in agreements"
      :key="agreement.id"
      :agreement="agreement"
      :value="getAgreementValue(agreement)"
      @input="$event => updateValue({ agreement, payload: $event })"
    />
  </div>
</template>

<script>
// @ts-check
import webcall from '@/libs/webcall';
import { Agreement } from '@/classes/agreement';
import AgreementRenderer from './AppAdditionalAgreements/AgreementRenderer';

/**
 * @typedef {Record<string, Record<string, string[]>>} AdditionalAgreementsValue
 */
/**
 * @type {() => AdditionalAgreementsValue}
 */
const AdditionalAgreementsValueType = Object;

export default {
  components: {
    AgreementRenderer,
  },
  props: {
    licenseRendererVm: {
      type: Object,
      required: true,
    },
    value: {
      type: AdditionalAgreementsValueType,
      required: true,
    },
  },

  data() {
    return {
      error: null,
      isLoading: false,
      agreements: [],
    };
  },

  mounted() {
    this.fetchAdditionalAgreements();
  },

  methods: {
    /**
     * @param {{
     *   agreement: Agreement;
     *   payload: Record<string, string[]>
     * }} data
     *
     * @fires #input
     */
    updateValue(data) {
      const { agreement, payload } = data;

      const eventPayload = {
        ...this.value,
        [agreement.code]: {
          ...payload,
        },
      };

      /**
       * @event #input
       * @type {AdditionalAgreementsValue}
       */
      this.$emit('input', eventPayload);
    },

    /**
     * @param {Agreement} agreement
     */
    getAgreementValue(agreement) {
      return this.value[agreement.code] || {};
    },

    fetchAdditionalAgreements() {
      this.isLoading = true;
      this.error = null;

      webcall.submission.additionalAgreements(this.$route.params.videoId)
        .then(({ data }) => {
          this.agreements = data.agreements.map(agreement => new Agreement(agreement));
          this.isLoading = false;
        })
        .catch((error) => {
          this.error = error;
          this.isLoading = false;
        })
      ;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/AppSpecificLicenseComponent/AppAdditionalAgreements.vue